export const CHECKOUT_DATA = 'CHECKOUT_DATA'

export const PAYMENT_VIEWS = {
  DETAILS: 'details',
  FORM: 'form'
} as const

export type PaymentViewTypes =
  (typeof PAYMENT_VIEWS)[keyof typeof PAYMENT_VIEWS]

export const BUTTONS_DATA_TEST_IDS = {
  CREDIT_CARD: 'creditCardButton',
  PAYPAL: 'paypalButton',
  PRZELEWY24: 'przelewy24Button',
  INVOICE: 'requestInvoiceButton'
} as const

export type ButtonsDataTestIdsTypes =
  (typeof BUTTONS_DATA_TEST_IDS)[keyof typeof BUTTONS_DATA_TEST_IDS]
